import { PublicResource } from '../../resource-types';
import { RawModel } from '../schema';

export type MetadataValueTypes =
  | 'string'
  | 'textarea'
  | 'number'
  | 'email'
  | 'phone_number'
  | 'date'
  | 'select'
  | 'multiselect'
  | 'recipients'
  | 'asset'
  | 'waterfall_select'
  | 'resource_picker'
  | 'generated'
  | 'custom';

export interface MetadataFieldType extends PublicResource {
  id: MetadataValueTypes;
  /** descirbes a valid schema for a validation schema of this field type (since those get generation in the advanced field settings editor) */
  json_schema: string;
  used_for_metadata: boolean;
  used_for_contracts: boolean;
}

export const metadataFieldType: RawModel = {
  type: 'metadata-field-type',
  plural: 'metadata-field-types',
  JSONApi: true,
  useWorker: true,
  attributes: {
    id: 'UUID',
    json_schema: 'string',
    used_for_metadata: 'boolean',
    used_for_contracts: 'boolean',
  },
  relationships: {
    only_for_workspaces: {
      type: 'workspace',
      binding: ['many', 'many'],
      reverse: 'metadata-field-types',
      required: false
    }
  }
};
